import { useQuery } from 'react-query';
import { getFeatureToggle } from 'services/featureToggle.services';

export const useFeatureToggle = (organizationSlug: string, keys: string[]) => {
  const { data, isLoading, error } = useQuery(
    ['feature-toggles', organizationSlug, keys],
    async () => getFeatureToggle(organizationSlug, keys),
    {
      enabled: !!organizationSlug,
    },
  );

  return {
    data,
    error,
    isLoading,
  };
};
